<!--
@create date 2023-7-27
@desc m220.phomemo.com
-->
<template>
  <div class="m220-guide-div">
    <div class="topContainerDivEx">
      <h1>M220 LABEL PRINTER SUPPORT</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/4aa12b8eca98c702e6c5058be260e336.jpg?v=1663226949"
            style="margin: 10px auto; width: 200px"
          />
        </div>
        <div class="rightDiv">
          <p>
            In addition to the printer support and repair resources on this
            page, also see the following:
          </p>
          <div class="linkDiv">
            <!--           <a href="https://www.amazon.com/dp/B09FL2Z63L" target="_blank">Amazon link</a> |  -->
            <a>Quick Start Guide</a> |
            <a
              href="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Phomemo_M220_Manual.pdf?v=1663226949"
              target="_blank"
              >Phomemo M220 Manual</a
            >
          </div>
          <p>
            Product registration is no longer necessary. Retain proof of
            purchase for warranty confirmation.
          </p>
          <hr
            style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
            v-show="!isMobile()"
          />
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/videosIcon.png?v=1663240699"
          style="margin: 0"
        />
        <div class="textContainer">HOW-TO VIDEOS</div>
      </div>
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            class="videoLogoImg"
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 0 auto"
          />
          <a class="a-link">For Windows</a>
        </div>
        <div class="centerDiv">
          <p>Windows 7 (32 and 64 bit)</p>
          <p>Windows 8 (32 and 64 bit)</p>
          <p>Windows 10 (32 and 64 bit)</p>
          <p>Windows 11 (64 bit)</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/How_to_use_M220_Label_Maker_for_PC-windows10.png?v=1663242574"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m220_windows_video.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
        v-show="isMobile()"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Mac</a>
        </div>
        <div class="centerDiv">
          <p>MacOS 10.14</p>
          <p>MacOS 10.15</p>
          <p>MacOS 10.11</p>
          <p>MacOS 12</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/How_to_use_M220_Label_Maker_for_Mac_OS.png?v=1663242576"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m220_mac_video.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">DRIVERS</div>
      </div>
      <div class="downloadTitleBar">
        <span>Phomemo Setup Utilities for Windows</span>
        <a
          href="https://oss.qu-in.life/Tianyi/LabelPrinter-WIN_EN.zip"
          target="_blank"
          title="Please Click to Download"
          @click="
            () => {
              refreshRecord({ key: 'M220_windowsDrivers' });
            }
          "
        >
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/downloadIcon.png?v=1663312898"
            style="width: 20px; position: relative; top: 2px"
          />
          &nbsp;Download&nbsp;&nbsp;&nbsp;182 MB
        </a>
      </div>
      <div class="downloadText">
        <p>
          Recommended driver installation and Labelife editing software
          (v2.0.2.729).
        </p>
        <p>
          OPERATING SYSTEM: Windows 7, Windows 8, Windows 10(32 and 64 bit)
          Windows 11(64 bit)
        </p>
      </div>
      <br v-show="!isMobile()" />
      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0px 15px 6px 11%"
        v-show="isMobile()"
      />
      <div class="downloadTitleBar">
        <span>Phomemo Setup Utilities for Mac</span>
        <a
          href="https://oss.qu-in.life/Tianyi/LabelPrinter-MAC_EN.zip"
          target="_blank"
          title="Please Click to Download"
          @click="
            () => {
              refreshRecord({ key: 'M220_macDrivers' });
            }
          "
        >
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/downloadIcon.png?v=1663312898"
            style="width: 20px; position: relative; top: 2px"
          />
          &nbsp;Download&nbsp;&nbsp;&nbsp;0.3 MB
        </a>
      </div>
      <div class="downloadText">
        <p>
          Recommended driver installation(QY-PrintDriver-1.1.0) and Labelife
          editing software.
        </p>
        <p>OPERATING SYSTEM: macOS 10.14, macOS 10.15, macOS 10.11, macOS 12</p>
      </div>
    </div>

    <div class="howToVideosDiv faqBarDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/faqsIcon.png?v=1663316214"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div class="faq-item" v-for="(item, index) in faqDataApp">
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/f10e2c4832c0faf086185700b226c940.png?v=1646813187"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/a016b412f93b877a827866a90379da25.png?v=1646813168"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--   联系方式 -->
    <div class="customServiceDiv">
      <div class="everyRow">
        Email：
        <a @click="() => {
            refreshRecord({ key: 'M220_email' });
            window.open('mailto:support@phomemo.com');
          }
          ">support@phomemo.com</a>
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">WhatsApp：+44 7355 725440</div>
    </div>
  </div>
</template>

<script>
import { refreshRecord, sensorsRecord } from "@/util.js";

const faqDataApp = [
  {
    title: "1. Can it be used on windows10? Need to download software?",
    details: [
      {
        theme:
          'Yes, log in to their official website to download the driver + "labelife" editing software; I use it to make address labels, and it works fine so far.',
      },
    ],
  },
  {
    title: "2. Portable label maker appears to print blank?",
    details: [
      {
        theme:
          "If When the app is connected correctly, there is a print blank, which is the case for most customers;",
        imgUrls: [],
      },
      {
        theme:
          "1. The printing paper is reversed：<br/>① Refer to the manual: 05.Printer Paper Roll Installation. <br/>② Watch the QA video of the page to learn how to install the paper roll;",
        imgUrls: [],
      },
      {
        theme:
          "2. The print head is damaged; please contact us for replacement;",
        imgUrls: [],
      },
    ],
  },
  {
    title: "3. Where do you buy replacement ink?",
    details: [
      {
        theme:
          "Thank you for your question, our Bluetooth Label Maker uses industry-leading thermal printing technology; no need for any ink, toner, or ribbon;",
        imgUrls: [],
      },
      {
        theme:
          'We provide common types of thermal paper for your use; <br />address label / barcode label : <a href="www.amazon.com/dp/B09FJRYJTY" target="_blank">www.amazon.com/dp/B09FJRYJTY</a> <br/>price label : <a href="www.amazon.com/dp/B09FJRMX2P" target="_blank">www.amazon.com/dp/B09FJRMX2P</a> <br/>ingredient label : <a href="https://www.amazon.com/dp/B09FJQKZWZ" target="_blank">https://www.amazon.com/dp/B09FJQKZWZ</a>',
        imgUrls: [],
      },
      {
        theme:
          "Inkless Portable Label Maker is perfect for small business and home use, don't hesitate to buy.",
        imgUrls: [],
      },
    ],
  },
  {
    title:
      "4. How long does the thermal “ink” last? Will it fade and disappear on the label?",
    details: [
      {
        theme:
          "①Our thermal paper can be stored for up to 10 years if it is protected from light, dark and normal temperature;It is recommended that when you use it, avoid direct contact with high temperature and exposure to the sun;",
        imgUrls: [],
      },
      {
        theme:
          'If you need any help, please contact us via the following ways:<br />E-mail✉ ▶ vip@phomemo.com ◀<br />Web.▶<a href="Phomemo.com/support" target="_blank">Phomemo.com/support</a>◀<br />+1855 957 5321 Mon-Fri: 9:00-5:00 EDT(US)',
        imgUrls: [],
      },
    ],
  },
  {
    title: "5. Does this come with labels?",
    details: [
      {
        theme:
          'Phomemo M220 label maker machine comes with 100pcs 1.57"x1.18"(40x30mm) label tapes.<br />If you print address labels, it is recommended that you purchase 2.35" x 1.57" size address labels <a href="https://www.amazon.com/dp/B09FJRYJTY" target="_blank">https://www.amazon.com/dp/B09FJRYJTY</a>.<br />We have large size 2.75" x 3.14" (70x80mm) labels: <a href="https://www.amazon.com/dp/B09FJQKZWZ" target="_blank">https://www.amazon.com/dp/B09FJQKZWZ</a>.',
        imgUrls: [],
      },
    ],
  },
  {
    title: "6. Is this printer / software can create unit bar code / QRcode?",
    details: [
      {
        theme:
          "Thanks for your question,Our Barcode Printer can easily create several kinds of labels as you say, and can also create Code128, Code39, Codabar, EAN-8, EAN--13 and so on;",
        imgUrls: [],
      },
      {
        theme: "If you still have questions, please contact us immediately.",
        imgUrls: [],
      },
    ],
  },
];
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
export default {
  name: "M220",
  props: {},
  data() {
    return {
      faqDataApp,
      activeQuestion2: {},
      isMobile,
      refreshRecord,
    };
  },
  mounted() {
    sensorsRecord({ key: "M220_view" }, 1);
    sensorsRecord({ key: "M220_WebStay" }, 3);
  },
  methods: {
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        refreshRecord({ key: "M220_FAQ" + (index + 1) });
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./m220.less" />



// WEBPACK FOOTER //
// src/view/guides/m220.vue